import script from "./EditUserView.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserView.vue?vue&type=script&setup=true&lang=js"

import "./EditUserView.vue?vue&type=style&index=0&id=7cc023e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc023e2"]])

export default __exports__